import { FC } from 'react'
import * as styles from 'components/features/coaching/advisorLandingPage/OverviewCoachSection/OverviewCoachSection.styl'
import SvgIcon from 'components/atoms/SvgIcon'
import ChartSvg from 'icons/chart.svg'
import TrendUpSvg from 'icons/trend_up.svg'
import FeedpostsSvg from 'icons/feedposts.svg'
import CreditScoreSvg from 'icons/creditscore.svg'
import NavFutureSvg from 'icons/nav-future.svg'
import AllSvg from 'icons/all.svg'
import ReactSvgIcon from 'icons/*.svg'

type FeatureDescriptor = {
  name: string
  icon: typeof ReactSvgIcon
  text: string
}

const FEATURE_DESCRIPTORS: FeatureDescriptor[] = [
  {
    name: 'Peer Comparisons',
    icon: ChartSvg,
    text: 'See how your finances compare with people like you and the national average.',
  },
  {
    name: 'Recommendations',
    icon: AllSvg,
    text: 'Our algorithms will analyze your finances to find ways for you to improve.',
  },
  {
    name: 'Financial Planning',
    icon: NavFutureSvg,
    text: 'Instantly simulate your future net worth by adding goals.',
  },
  {
    name: 'Community',
    icon: FeedpostsSvg,
    text: 'Anonymously chat with hundreds of thousands of Status members.',
  },
  {
    name: 'Net Worth Tracking',
    icon: TrendUpSvg,
    text: 'Stay on top of all your accounts with daily net worth tracking.',
  },
  {
    name: 'Credit Monitoring',
    icon: CreditScoreSvg,
    text: 'Track your credit score and get alerts when accounts are added to your credit file.',
  },
]

export const OverviewCoachSection: FC = () => {
  const lineBreakChild = (
    <span className={ styles.lineBreak }>{ ' ' }</span>
  )

  return (
    <section className={ styles.overviewCoachSection }>
      <h2 className={ styles.header }>
        Plus,{ lineBreakChild }get everything you need to manage your money.
      </h2>
      <ul className={ styles.features }>
        {
          FEATURE_DESCRIPTORS.map(({ name, text, icon }) => {
            return (
              <li key={ name } className={ styles.feature }>
                <h4 className={ styles.featureHeader }>
                  <div className={ styles.iconWrapper }>
                    <SvgIcon src={ icon } />
                  </div>
                  { name }
                </h4>
                <p className={ styles.featureText }>
                  { text }
                </p>
              </li>
            )
          })
        }
      </ul>
    </section>
  )
}

